export default {
    "button.continue": "Continue",
    "button.finish": "Finish",
    "forgot_password_label_submit": "Forgot Password",
    "login.email.placeholder": "E-Mail",
    "login.heading": "Welcome to Actlang",
    "login.registration.link": "Create a new account",
    "login_label_password": "Password*:",
    "login_label_submit": "Login",
    "password_email_error_invalid": "Please enter a valid password",
    "projects.create": "Create a new project",
    "projectsForm.delete": "Delete",
    "projectsForm.fallback.placeholder": "Fallback",
    "projectsForm.heading.editing": "Editing",
    "projectsForm.heading.new": "New project",
    "projectsForm.locales.label": "Locales",
    "projectsForm.name.label": "Name",
    "projectsForm.save.new": "Create",
    "projectsForm.save.update": "Save",
    "projectsForm.users.label": "Users",
    "projectsList.created_at": "Created at",
    "projectsList.name": "Name",
    "register_company_error_empty": "Please enter your company name",
    "register_email_error_invalid": "Please enter a valid email",
    "register_email_error_unequal": "The email does not match the previous email",
    "register_firstname_error_empty": "Please enter your firstname",
    "register_label_company_name": "Company Name*:",
    "register_label_email": "E-Mail*:",
    "register_label_email_verification": "E-Mail-Verification*:",
    "register_label_firstname": "Firstname*:",
    "register_label_lastname": "Lastname*:",
    "register_label_submit": "Register",
    "register_lastname_error_empty": "Please enter your lastname",
    "registration.errors.email_in_use": "The email address is already registered.",
    "registration.errors.email_invalid": "The email address is invalid.",
    "registration.errors.email_required": "Please provide a valid email address.",
    "registration.errors.email_verification_code_invalid": "The email verification code is invalid.",
    "registration.errors.password_confirm": "The password do not match.",
    "registration.errors.password_required": "Please provide a password.",
    "registration.errors.password_too_short": "The password has to have at least 8 characters.",
    "registration.errors.upload_error": "An error occured while uploading the image.",
    "registration.errors.username_in_use": "The username is already registered.",
    "registration.errors.username_required": "Please provide a username.",
    "registration.errors.username_too_short": "The username is too short.",
    "registration.heading": "Create a new account",
    "selectlist.add": "Add",
    "tenants.create": "Create a new tenant",
    "tenantsForm.delete": "Delete",
    "tenantsForm.heading.editing": "Editing",
    "tenantsForm.heading.new": "New tenant",
    "tenantsForm.name.label": "Name",
    "tenantsForm.save.new": "Create",
    "tenantsForm.save.update": "Save",
    "tenantsList.created_at": "Created at",
    "tenantsList.name": "Name",
    "translations_list_editor.iconbar.download_package": "Download Package",
    "translations_list_editor.iconbar.upload_default_messages": "Upload Default Messages",
    "translations_list_editor.iconbar.upload_locale_messages": "Upload Translated Messages",
    "translationslistwitheditor.th.defaultMessage": "Source Code Text",
    "translationslistwitheditor.th.fallbackMessage": "Parent Text",
    "translationslistwitheditor.th.id": "ID",
    "translationslistwitheditor.th.translation": "Translation",
    "users.create": "Create a new user",
    "usersForm.admin.label": "Admin",
    "usersForm.delete": "Delete",
    "usersForm.email.label": "Email",
    "usersForm.heading.editing": "Editing",
    "usersForm.heading.new": "New user",
    "usersForm.is_gobal_admin.label": "Global-Admin",
    "usersForm.is_tenant_admin.label": "Admin (Company-wide)",
    "usersForm.is_tenant_translator.label": "Translator (Company-wide)",
    "usersForm.locales.label": "Locales",
    "usersForm.name.label": "Name",
    "usersForm.old_password.label": "Old Password",
    "usersForm.password.label": "Password",
    "usersForm.password_confirm.label": "Password (Confirm)",
    "usersForm.projects.label": "Projects",
    "usersForm.save.new": "Create",
    "usersForm.save.update": "Save",
    "usersList.created_at": "Created at",
    "usersList.username": "Username",
    "welcome": "Hello in English"
};



// WEBPACK FOOTER //
// ./src/messages/en.js